<template>
  <main-page :user="user" color="blue">
    <template v-slot:title>
      <template> {{ pageTitle }} </template>
    </template>
    <div class="container">
      <div v-if="team" class="row content">
        <div v-if="!selectedAssignment" class="col-12">
          <div class="mx-auto d-flex flex-column" style="max-width: 500px">
            <h3 class="flex-grow text-left si-font my-1 pb-0">Select an Assignment</h3>
            <div
              v-for="canvas in canvasAssignments"
              :key="canvas.id"
              class="card mt-2 p-1 w-100 black-border"
              :class="{
                'text-muted': !canvas.available && !canvas.past,
              }"
            >
              <div class="d-flex flex-row align-items-center px-2">
                <div class="flex-grow">
                  <div class="flex-grow text-left text-md">
                    {{ canvas.name }}
                  </div>
                  <template v-if="canvas.canvas && canvas.canvas.updated_at">
                    <div class="mb-0 text-muted text-left">Last Edited:</div>
                    <div class="mb-1 text-muted text-left" style="line-height: 1">
                      {{ fs.shortDate(canvas.canvas.updated_at) }}
                    </div>
                  </template>
                  <div class="mb-0 text-muted text-left">Available:</div>
                  <div class="mb-1 text-muted text-left" style="line-height: 1">
                    {{ fs.shortDate(canvas.start) }} to
                    {{ fs.shortDate(canvas.end) }}
                  </div>
                </div>
                <template v-if="canvas.available">
                  <button
                    v-if="!canvas.locked && canvas.id"
                    class="btn btn-no-border btn-si-yellow btn-same-width"
                    @click="chooseAssignment(canvas)"
                  >
                    Open
                  </button>
                  <button
                    v-if="canvas.locked"
                    class="btn btn-no-border btn-si-gray btn-same-width"
                    disabled
                  >
                    Locked
                  </button>
                </template>
                <template v-else>
                  <button
                    v-if="!canvas.past"
                    class="btn btn-no-border btn-si-gray btn-same-width"
                    disabled
                  >
                    Unavailable
                  </button>
                  <button
                    v-if="canvas.past"
                    class="btn btn-no-border btn-si-green btn-same-width"
                    @click="chooseAssignment(canvas)"
                  >
                    View
                  </button>
                </template>
              </div>
            </div>
          </div>
          <div
            v-if="canvasAssignments.length == 0"
            class="text-center text-very-muted text-lg _800 mt-2"
          >
            No Canvas assignments
          </div>
        </div>
        <div
          v-if="selectedAssignment && selectedAssignment.canvas"
          style="min-height: 750px; overflow: visible"
          class="full-width"
        >
          <div class="text-md" style="text-align: left">
            Team Members: {{ listTeammates }}
          </div>
          <CanvasView
            :canEdit="selectedAssignment.available"
            :canvasData="selectedAssignment.canvas"
            :user="user"
            :program="program"
          />
        </div>
      </div>
      <div v-if="!team">
        <h1 class="text-extra-muted mt-5" style="font-size: 64px">No Team</h1>
        <h3 class="text-extra-muted">
          You must be on a team in this class to fill out an Innovator Canvas. Please contact your teacher to put
          you on a team.
        </h3>
      </div>
    </div>
    <template v-slot:footer>
      <div class="col-6 text-right">
          <button
            v-if="selectedAssignment"
            class="btn btn-si-secondary"
            @click="goBack"
          >
            Back
          </button>
          <a v-if="!selectedAssignment" class="btn btn-si-secondary" href="#/canvas">
            Back
          </a>
        </div>
    </template>
  </main-page>
</template>

<script>
import SectionService from "@/services/SectionService";
import ProgramService from "@/services/ProgramService";
import TeamService from "@/services/TeamService";
import CanvasService from "@/services/CanvasService";

import MainPage from "@/components/MainPage";
import CanvasView from "@/components/CanvasView";

import Notie from "@/services/NotieService";
import BB from "bluebird";
import fs from "@/services/FormatService";
import _ from "lodash";
import moment from "moment"

export default {
  name: "CanvasEdit",

  props: ["user"],

  components: { MainPage, CanvasView },

  data() {
    return {
      fs: fs,

      context: null,
      canvasAssignments: [],
      selectedAssignment: null,
      team: null,
      selectedCanvas: null,
      canvases: null,

      program: null,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    pageTitle() {
      if (this.selectedAssignment) {
        return this.selectedAssignment.name;
      } else {
        return "EDIT CANVAS";
      }
    },

    listTeammates() {
      var teammates = [];
      _.each(this.context.students, (student) => {
        if (this.team.user_ids.includes(student.id)) {
          teammates.push(fs.displayName(student.name));
        }
      });

      return teammates.join(", ");
    },
  },

  methods: {
    loadData() {
      BB.props({
        context: SectionService.getContextPrefilled(),
        team: TeamService.getContextTeam(),
      })
        .then((r) => {
          this.loading = false;
          this.context = r.context.data;
          this.canvasAssignments = this.context.canvases;
          this.team = r.team.data;

          _.each(this.canvasAssignments, (ca) => {
            ca.available = fs.withinWindow(ca.start, ca.end);
            ca.past = moment().isAfter(moment(ca.end).endOf("day"))
          });

          if (this.team) {
            CanvasService.getCanvases(this.team.id)
              .then((r) => {
                this.canvases = r.data;
                console.log(this.canvases);

                _.each(this.canvasAssignments, (ca) => {
                  ca.canvas = _.find(this.canvases, {
                    team_id: this.team.id,
                    assignment_id: ca.id,
                  });
                  console.log("FOUND CANVAS");
                  console.log(ca.canvas);
                  if (ca.canvas == null) {
                    ca.canvas = {
                      responses: {
                        problem: "",
                        partners: "",
                        activities: "",
                        resources: "",
                        values: "",
                        relationships: "",
                        channels: "",
                        segments: "",
                        discovery: "",
                        cost: "",
                        revenue: "",
                      },
                      locks: {
                        problem: { locked: false },
                        partners: { locked: false },
                        activities: { locked: false },
                        resources: { locked: false },
                        values: { locked: false },
                        relationships: { locked: false },
                        channels: { locked: false },
                        segments: { locked: false },
                        discovery: { locked: false },
                        cost: { locked: false },
                        revenue: { locked: false },
                      },

                      assignment_id: ca.id,
                      team_id: this.team.id,
                      id: "",
                    };
                  }
                  console.log(ca.canvas);
                });
                console.log(this.canvasAssignments);

                ProgramService.getContextProgram()
                  .then((r) => {
                    this.program = r.data;
                  })
                  .catch((e) => {
                    console.log(e);
                    Notie.error("Failed to load program", e);
                  });
              })
              .catch((e) => {
                this.loading = false;
                console.log(e);
                Notie.error("Failed to load canvases", e);
              });
          }
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          Notie.error("Failed to load context", e);
        });
    },

    chooseAssignment(assignment) {
      console.log("ASSIGNMENT", assignment);
      if (assignment.canvas.id.length > 0) {
        CanvasService.getCanvas(assignment.canvas.id)
          .then((r) => {
            assignment.canvas = r.data;
            this.selectedAssignment = assignment;
          })
          .catch((e) => {
            console.log(e);
            Notie.error("Failed to load canvas");
          });
      } else {
        this.selectedAssignment = assignment;
      }
    },

    goBack() {
      this.$nextTick(() => {
        this.selectedAssignment = null;
      });
    },
  },
};
</script>

<style scoped>
.content {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.black-border {
  border: 2px solid rgb(128, 128, 128);
}

.btn-same-width {
  width: 120px;
}
.full-width {
  max-width: 90vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -45vw;
  margin-right: -45vw;
}
</style>
